import { AbstractControl } from '@angular/forms';
import { BaseVariableControl } from './_base-control';



export class VariableSpecificControl extends BaseVariableControl {

}
